import { useCallback, useEffect, useState } from 'react';
import { Icon, IconColor, IconID } from '@hub/common/Icon/Icon';
import classNames from 'classnames';

export const ScrollToTopButton = () => {
  const [isVisible, setVisible] = useState(false);

  const scrollToTop = useCallback(() => {
    if (isVisible) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [isVisible]);

  const checkPosition = useCallback(() => {
    setVisible(window.pageYOffset > 1000);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', checkPosition);
    return () => window.removeEventListener('scroll', checkPosition);
  }, [checkPosition]);

  return (
    <div
      data-testid="scroll-to-top-button"
      onClick={scrollToTop}
      className={classNames(
        'fixed',
        'bottom-1',
        'bg-igus-primary',
        'p-6',
        'border-2',
        'border-white',
        'z-50',
        'cursor-pointer',
        'transition-all',
        'duration-1000',
        'ease-in-out',
        'mb-3',
        'md:mb-20',
        isVisible ? 'opacity-100' : 'opacity-0 invisible'
      )}
      style={{ left: '100vw', transform: 'translateX(calc(-100% - 2rem))', zIndex: 1000 }}
    >
      <Icon id={IconID.ARROW_UP} size={6} color={IconColor.WHITE} />
    </div>
  );
};
